import { Carousel, RoleCard } from "../../components";

function OurPeople({ data }) {
    
    return (
        <div id="ourpeople" className="container" >
            <div className="infos">
                <h3>{ data.title }</h3>
            </div>
            <div className="rates">
                <Carousel chevronsOn={!data.carouselConf.pointsOn} pointsOn={data.carouselConf.pointsOn} timer={data.carouselConf.time} nbElements={1} >
                    {data.moderators.map((e, k) => <RoleCard key={ k } data={ e } />)}
                </Carousel>
            </div>
        </div>
    )
}

export default OurPeople
